import React, { FC, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getBread } from 'reducks/bread/selectors'
import { fetchBread } from 'reducks/bread/operations'
import { DeliveryScheduleEditCompleteTemplate } from 'components/Templates'
import { getBreadShortName } from 'lib/helper'

const DeliveryScheduleEditComplete: FC = () => {
  const dispatch = useDispatch()
  const path = useSelector((state: State) => state.router.location.pathname)
  // ブラウザバックしたときに異なるパスでbreadIdを判定してfetchすることを防ぐ
  const paths = /^\/schedule\/delivery\/.+\/complete$/.test(path) ? path.split('/') : []
  const breadId = paths.length > 0 ? paths[paths.length - 2] : undefined
  const bread = useSelector((state: State) => getBread(state))
  useEffect(() => {
    if (!breadId || breadId === '') return
    dispatch(fetchBread(breadId))
  }, [breadId])
  if (!bread) return <></>
  return (
    <Layout title={`${getBreadShortName(bread)}のお届け可能日設定完了`}>
      <DeliveryScheduleEditCompleteTemplate />
    </Layout>
  )
}

export default DeliveryScheduleEditComplete
